<template>
  <el-dialog
      v-el-drag-dialog
      title="被锁定的账号"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="500px"
      top="3vh">
    <el-table v-loading="contentLoading" border stripe :data="tableData">
      <el-table-column
          prop="username"
          align="center"
          label="账号"/>
      <el-table-column
          align="center"
          label="操作">
        <template v-slot="scope">
          <el-button type="danger" @click="unlock(scope.row.username)">解锁</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        tableData: [],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic","captcha/lockedUsers")
          .then(res => {
            this.tableData = res;
          })
          .finally(() => {
            this.contentLoading = false;
          });
      },
      unlock(username) {
        this.$http
          .get("basic", "captcha/unlock?username=" + username)
          .then(() => {
            this.$message.success("解锁成功");
            this.getData();
          });
      },
    },
  };

</script>
<style lang="scss" scoped>
</style>
